// DEUTSCHES Fragment des Bereichs « règles »: Spielregeln (/regles-de-jeu, Ziel
// des QR-Codes auf der Box), Bestellung erfolgreich (/success) und 404-Seite.
// KONSISTENZ: die Fragen 5, 7 und 11 werden in de/experience.js identisch
// wiederholt (demo.question.*) — jede Änderung hier muss dort nachgezogen
// werden. Die Schätzfrage der Demo (demo.subsidiaire.question) ist ABSICHTLICH
// eine andere: die Startseite verrät die echte nie.
// MIT DER DRUCKEREI ABZUKLÄREN: liegt der Box eine deutsche Anleitung bei, müssen
// diese 11 Fragen deren exakten Wortlaut übernehmen.
// NB: die Antwort auf die Schätzfrage hat bewusst KEINEN Schlüssel: sie darf nur
// in GameRules.jsx stehen, hinter dem Klick « nur für die Eltern ».
export default {
  // --- Règles du jeu : SEO ---
  'regles.seo.titre': 'Spielregeln von Joyful Reveal',
  'regles.seo.description':
    'Die vollständigen Spielregeln des Gender-Reveal-Spiels Joyful Reveal: Bilden Sie zwei Teams, beantworten Sie die 11 Fragen, legen Sie das Puzzle zusammen und rubbeln Sie das letzte Teil frei, das das Geschlecht des Babys verrät.',

  // --- Règles du jeu : en-tête ---
  'regles.entete.titre': 'Die Spielregeln',
  'regles.entete.introAvant':
    'Zwei Teams, 11 Fragen, ein Puzzle zum Zusammenlegen und ein letztes Teil zum Freirubbeln. Rechnen Sie mit rund',
  'regles.entete.introDuree': '20 Minuten',
  'regles.entete.introEntre': ', für',
  'regles.entete.introJoueurs': '2 bis 10 Spieler',

  // --- Règles du jeu : avertissement invités ---
  'regles.invite.titre': '🤫 Sind Sie zu einer Feier eingeladen?',
  'regles.invite.destinee': 'Diese Seite ist für die',
  'regles.invite.parents': 'werdenden Eltern',
  'regles.invite.suite':
    'gedacht, die das Spiel vorbereiten. Wenn Sie mitspielen, schließen Sie sie lieber wieder: Sie würden sich Ihre eigene Überraschung verderben!',

  // --- Règles du jeu : contenu du kit ---
  'regles.kit.titre': '🎁 Das enthält Ihr Set',
  'regles.kit.sachetAvant': 'Ein Hauptbeutel mit',
  'regles.kit.sachetPieces': '11 Puzzleteilen',
  'regles.kit.grattoirAvant': 'und',
  'regles.kit.grattoirPiece': 'ein einzigartiges Rubbelteil',
  'regles.kit.grattoirFin': '— das Teil, das alles verrät.',
  'regles.kit.premium':
    'Das Pack Premium ergänzt die beiden Team-Stoffbeutel, den auf 400-g-Karton gedruckten Fragebogen und den Erinnerungsumschlag, den Sie nach dem Fest hinten an einem Bilderrahmen befestigen.',

  // --- Règles du jeu : les 4 étapes ---
  'regles.etape1.titre': 'Bevor die Gäste eintreffen',
  'regles.etape1.alt':
    'Der Inhalt des Spiels Joyful Reveal ausgebreitet: die Box, der Fragebogen und die beiden Stoffbeutel',
  'regles.etape1.p1':
    'Die werdenden Eltern wählen die 11 Fragen aus, die die Spieler beantworten müssen. Jede richtige Antwort bringt ein Puzzleteil ein.',
  'regles.etape1.p2':
    'Die Antwort lautet immer „Mama“ oder „Papa“ — und ist natürlich mit einem Augenzwinkern gemeint!',
  'regles.etape1.p3':
    'Sie können unsere fertige Liste verwenden (weiter unten) oder mit der leeren Vorlage eigene Fragen erfinden.',

  'regles.etape2.titre': 'Bilden Sie die zwei Teams',
  'regles.etape2.alt': 'Die beiden Stoffbeutel des Spiels, beschriftet mit Team 1 und Team 2',
  'regles.etape2.p1': 'Teilen Sie Ihre Gäste in zwei Teams auf — zum Beispiel:',
  'regles.etape2.equipe1Label': 'Team 1',
  'regles.etape2.equipe1Texte': 'alle, die glauben, dass das Baby ein Mädchen wird 💗',
  'regles.etape2.equipe2Label': 'Team 2',
  'regles.etape2.equipe2Texte': 'alle, die glauben, dass das Baby ein Junge wird 💙',

  'regles.etape3.titre': 'Das Spiel: die 11 Teile gewinnen',
  'regles.etape3.alt':
    'Rückseite der Box Joyful Reveal mit einer Übersicht der 4 Spielschritte',
  'regles.etape3.p1':
    'Die werdenden Eltern stellen die Fragen eine nach der anderen. Das Team, das als Erstes die richtige Antwort gibt, gewinnt ein Puzzleteil.',
  'regles.etape3.p2': 'So geht es weiter, bis alle 11 klassischen Teile vergeben sind.',
  'regles.etape3.p3':
    'Sind die 11 Teile gewonnen, legen die beiden Teams das Puzzle gemeinsam zusammen… und es fehlt nur noch ein einziges Teil!',

  'regles.etape4.titre': 'Das letzte Teil: die große Enthüllung',
  'regles.etape4.alt': 'Die Box des Spiels Joyful Reveal mit dem Puzzleteil zum Freirubbeln',
  'regles.etape4.p1':
    'Nur das Team mit den meisten gewonnenen Teilen darf diese letzte Runde spielen — und diesmal spielt jeder Spieler für sich.',
  'regles.etape4.p2':
    'Die werdenden Eltern stellen nun die Schätzfrage. Der Spieler, dessen Schätzung am nächsten liegt, gewinnt das letzte Teil… und das Vorrecht, es freizurubbeln!',

  // --- Règles du jeu : question subsidiaire (la réponse reste dans le JSX) ---
  'regles.subsidiaire.surtitre': 'Die Schätzfrage',
  'regles.subsidiaire.question':
    '„Wie viele Wegwerfwindeln verbrauchen junge Eltern im ersten Lebensjahr ihres Babys im Durchschnitt?“',
  'regles.subsidiaire.reponseLabel': 'Antwort:',
  'regles.subsidiaire.bouton': '👀 Antwort anzeigen (nur für die Eltern)',
  'regles.subsidiaire.libre':
    'Es ist unsere Lieblingsfrage — aber wählen Sie gern Ihre eigene: Die Antwort muss nur eine schätzbare Zahl sein.',

  // --- Règles du jeu : le conseil ---
  'regles.conseil.surtitre': '💡 Kleiner Tipp',
  'regles.conseil.titre': 'Widerstehen Sie der Versuchung, Ihre Gäste vorzuwarnen!',
  'regles.conseil.texte':
    'Stellen Sie sich ihre Reaktion vor, wenn sie das Spiel entdecken und merken, dass sie gleich einen einzigartigen Moment voller Spannung erleben. Es lohnt sich wirklich, ihre Gesichter aufleuchten zu sehen. Also halten Sie durch und verraten Sie Ihr Geheimnis nicht!',

  // --- Règles du jeu : les 11 questions ---
  'regles.questions.titre': '📝 Die 11 spielfertigen Fragen',
  'regles.questions.imprimer': '🖨️ Drucken',
  'regles.questions.q1': 'Wer kann besser Babybrei zubereiten?',
  'regles.questions.q2': 'Wer gerät bei der Geburt eher in Panik?',
  'regles.questions.q3':
    'Wer merkt sich leichter Größe und Gewicht des Babys bei der Geburt?',
  'regles.questions.q4': 'Wer tut sich beim Windelnwechseln am schwersten?',
  'regles.questions.q5': 'Wer singt Schlaflieder katastrophal?',
  'regles.questions.q6': 'Wer kann süßen, aber unnützen Babysachen nicht widerstehen?',
  'regles.questions.q7': 'Wer weint bei Kinderfilmen?',
  'regles.questions.q8': 'Wer schneidet die besten Grimassen, um das Baby zum Lachen zu bringen?',
  'regles.questions.q9':
    'Wer versteht am ehesten nicht, wie man dem Baby die Kleidung anzieht?',
  'regles.questions.q10': 'Wer erzählt die besten Geschichten, um das Baby einzuschläfern?',
  'regles.questions.q11':
    'Wer könnte das Baby versehentlich wecken, weil er auf ein lautes Spielzeug tritt?',
  'regles.questions.persoAvant':
    'Lust auf eine persönliche Note? Ersetzen Sie diese Fragen gern durch Ihre eigenen — wichtig ist nur, dass es immer bei zwei möglichen Antworten bleibt:',
  'regles.questions.persoMaman': '„Mama“',
  'regles.questions.persoOu': 'oder',
  'regles.questions.persoPapa': '„Papa“',
  'regles.questions.persoFin': '. Das Pack Premium enthält eine leere Vorlage genau dafür.',

  // --- Règles du jeu : CTA final ---
  'regles.cta.titre': 'Sie haben das Spiel noch nicht?',
  'regles.cta.texte': 'Viel Spaß — und noch einmal herzlichen Glückwunsch, liebe werdende Eltern! 🎉',
  'regles.cta.bouton': '🛒 Das Spiel entdecken',

  // --- Page 404 (NotFound.jsx), rangée sous « regles » faute d'espace dédié ---
  'regles.introuvable.seoTitre': '404 - Seite nicht gefunden',
  'regles.introuvable.seoDescription':
    'Die gesuchte Seite existiert nicht. Kehren Sie zur Startseite zurück oder entdecken Sie unseren Shop.',
  'regles.introuvable.titre': '404 - Hoppla!',
  'regles.introuvable.sousTitre': 'Die gesuchte Seite konnte nicht gefunden werden.',
  'regles.introuvable.texte':
    'Möglicherweise wurde die Seite gelöscht oder verschoben, oder die URL ist nicht korrekt.',
  'regles.introuvable.boutonAccueil': '🏠 Zurück zur Startseite',
  'regles.introuvable.boutonBoutique': '🛍️ Zum Shop',
  'regles.introuvable.aide': 'Brauchen Sie Hilfe?',
  'regles.introuvable.aideLien': 'Kontaktieren Sie uns',

  // --- Commande réussie (Success.jsx) ---
  'succes.chargement.titre': 'Ihre Bestellung wird abgeschlossen...',
  'succes.chargement.texte':
    'Wir rufen Ihre Sendungsnummer ab, das dauert nicht lange.',
  'succes.entete.titre': 'Bestellung erfolgreich!',
  'succes.entete.numeroLabel': 'Bestellnummer:',
  'succes.entete.merci':
    'Vielen Dank für Ihren Einkauf! Sie erhalten eine Bestätigungs-E-Mail mit den Einzelheiten Ihrer Bestellung und Ihrer Rechnung.',
  'succes.suivi.titre': 'Ihr Paket verfolgen',
  'succes.suivi.etiquette': 'Ihr Versandetikett wurde erstellt!',
  'succes.suivi.numeroLabel': 'Sendungsnummer:',
  'succes.suivi.bouton': '🚚 Mein Paket verfolgen',
  'succes.suivi.astuce':
    '💡 Sie finden diesen Link auch in Ihrem Profil → Meine Bestellungen',
  'succes.attente.texte':
    'Ihre Bestellung wird bearbeitet. Die Sendungsnummer erscheint in Kürze in Ihrem Kundenbereich.',
  // Das PDF verrät die Antwort auf die Schätzfrage — der Warnhinweis darf beim
  // Übersetzen nie wegfallen, und die Antwort selbst steht in KEINEM Schlüssel.
  // Affiché quand la session de paiement n'est plus lisible (lien rouvert
  // des semaines plus tard) : la page restait alors amputée EN SILENCE —
  // ni numéro de commande, ni guide, ni facture, et aucune explication.
  'succes.introuvable.texte':
    "Ihre Zahlung war erfolgreich. Wir können die Details dieser Bestellung hier nur nicht anzeigen — das passiert, wenn dieser Link später erneut geöffnet wird. Ihre Bestätigungs-E-Mail enthält Ihre Bestellnummer und Ihre Rechnung; schreiben Sie uns, falls Sie sie nicht finden.",
  'succes.guide.titre': 'Ihre Spielanleitung',
  'succes.guide.texte':
    'Das komplette Heft, mit den 11 spielfertigen Fragen und der leeren Vorlage für Ihre eigenen. Halten Sie es am großen Tag griffbereit.',
  'succes.guide.bouton': '📥 Anleitung herunterladen (PDF)',
  'succes.guide.avertissement':
    '⚠️ Nur für die werdenden Eltern: Darin steht die Antwort auf die Schätzfrage.',

  'succes.questionnaire.titre': 'Ihr Erinnerungs-Fragebogen',
  'succes.questionnaire.texte':
    'Der druckfertige Quizbogen im Format der Karte aus dem Spiel: die 11 Fragen und die Team-Spalten. Setzen Sie das Häkchen für eine Blanko-Version, die Sie mit eigenen Fragen füllen.',
  'succes.questionnaire.vierge': 'Blanko-Version (für Ihre eigenen Fragen)',
  'succes.questionnaire.bouton': '📥 Fragebogen herunterladen (PDF)',
  'succes.questionnaire.avertissement':
    '⚠️ Nur für die werdenden Eltern: Auf der Rückseite steht die Antwort auf die Schätzfrage.',

  "succes.facture.titre": "Ihre Rechnung",
  "succes.facture.texte":
    "Die Rechnung zu Ihrer Bestellung (auf Französisch) liegt bereit. Stripe sendet Ihnen zusätzlich eine Zahlungsquittung per E-Mail.",
  "succes.facture.bouton": "🧾 Rechnung ansehen und drucken",
  'succes.avis.titre': 'Ihre Bewertung zählt!',
  'succes.avis.texte':
    'Teilen Sie Ihre Erfahrung und helfen Sie anderen Kunden, unsere Produkte zu entdecken.',
  'succes.avis.bouton': '✍️ Eine Bewertung schreiben',
  'succes.actions.commandes': '📋 Meine Bestellungen ansehen',
  'succes.actions.boutique': '🎮 Weiter einkaufen',
};
